import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateCampaignForm } from './CreateCampaignForm';

// Styles
import { useCreateCampaign } from '@Modal/hooks/campaigns/useCreateCampaign';

export const CreateCampaignModalDialog = () => {
  const { showCreateCampaignForm, handleCreateCancel } = useCreateCampaign();

  return (
    <>
      {showCreateCampaignForm && (
        <ClosableModal
          name="CreateCampaign"
          title="Create Campaign"
          open={showCreateCampaignForm}
          onClose={handleCreateCancel}
          sx={{ width: '592px', overflowY: 'scroll', maxHeight: '90vh' }}
        >
          <CreateCampaignForm />
        </ClosableModal>
      )}
    </>
  );
};
